import React from "react";
import Label from "components/general/Label"
import DateTime from "components/presentation/DateTime"
import { isLiveStatus, isLessLiveStatus } from "helpers/status";
import Status from "components/presentation/Status";
import Noc from "components/presentation/Noc";
import Competitor from "components/presentation/Competitor";
import SportCode from "components/common/SportCode";
import { useUrlFriendlyToParameters } from "helpers/urlFriendly";
import { getDateTimeFormat } from "helpers/utils";


export function Footer({ data }) {

    const formatDate = getDateTimeFormat('DayMonthShort')
    const formatDateTime = getDateTimeFormat('DayMonthShortHourMinute');
    const dateTime = data?.bi_date + ' ' + data?.bi_time
    const dateTimeFormated = data?.bi_date && <DateTime datetime={dateTime} format={formatDateTime} />
    const date = data?.bi_date && <><DateTime datetime={data?.bi_date} format={formatDate} />, <SportCode entity='@CompetitorPlace' code="TBD" abbr={true} /></>
    const dateComponent = data?.bi_time ? dateTimeFormated : date
    const numberGame = data?.bracketItemCode
    let isLive = isLiveStatus(data?.result?.status?.code);
    let isLessLive = isLessLiveStatus(data?.result?.status?.code);
    return (
        <>
            {isLive && <div className='score-status justify-content-end'>
                <Status typeToPrint={'result'} scheduleStatus={data?.schedule?.status?.code} resultStatus={data?.result?.status?.code} />
            </div>}
            <div className="d-flex w-100">
                {isLessLive && <div className='text-start w-50'>{dateComponent ? dateComponent : <SportCode entity='@CompetitorPlace' code="TBD" abbr={true} />}</div>}
                {isLessLive && <div className='text-end w-50'><Label data='HeaderMatch' /> {numberGame}</div>}
            </div>
        </>
    )
}

export function CompetitorBlockNoData(competitor) {
    const { mirs_discipline } = useUrlFriendlyToParameters()
    let competitorPlace = competitor?.cp_code ? <SportCode discipline={mirs_discipline} entity='@CompetitorPlace' code={competitor?.cp_code} notFound={<>&nbsp;</>} /> : ''
   
    return (
        <div className='score-competitor-container  d-flex flex-row justify-content-start'>
            <div className='score-name'>
                {competitor?.cp_code === 'NOCOMP' || competitor?.cp_code === 'BYE'
                     ? competitorPlace
                    : !competitor.cp_prev_wlt && competitor?.cp_prev_value
                        ? <SportCode discipline={mirs_discipline} entity='@Pool' code={competitor?.cp_prev_value} />
                        : <></>
                }
            </div>
        </div>
    )
}
export function CompetitorBlock(competitor) {
    let bolding = competitor?.cp_wlt === 'W' ? ' fw-bold' : '';
    let strike = competitor?.cp_strike_out === 'Y' ? ' text-decoration-line-through' : '';

    return (
        <div className={'score-competitor-container  d-flex flex-row justify-content-start ' + bolding}>
            {/*<div className='score-uniform score-uniform-home'></div>*/}
            <div className='score-noc'>
                <Noc className='me-1' {...competitor?.participant?.organisation} />
            </div>
            <div className={'score-name' + strike}><Competitor  {...competitor?.participant} hideNoc={true} hidePicture={true} noLink={true} onlyShortName={true} screen={competitor.screen} /> </div>
        </div>
    )
}

function PlayerPosition({ pos }) {
    switch (pos) {
        case '1':
            return (
                <>
                    {pos + 'st'}
                </>
            )
        case '2':
            return (
                <>
                    {pos + 'nd'}
                </>
            )
        case '3':
            return (
                <>
                    {pos + 'rd'}
                </>
            )
        case '4': case '5': case '6': case '7': case '8':
            return (
                <>
                    {pos + 'th'}
                </>
            )
    }
}
